export enum LocalStorageKeys {
    Jwt = 'jwt',
    User = 'user',
}
